import { createFileRoute } from '@tanstack/react-router'
import { claimTypesEnum } from 'User/utils/claims'
import ActivityGridSearch from 'Work/components/Activities/Search/ActivityGridSearch'
import { Suspense } from 'react'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/work/activities/')({
    validateSearch: (search: Record<string, string>) => search,
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_work]}>
            <Suspense fallback={<PageSkeleton variant="grid" wrapper="page" />}>
                <ActivityGridSearch />
            </Suspense>
        </Guard>
    ),
})
